// antd InputNumber n'empêche pas de taper des lettres : rc-input-number garde
// la saisie brute dans le champ et se contente de la rejeter au blur. En
// attendant, le champ affiche « abc » et onChange rend null — visuellement,
// c'est un champ numérique qui accepte du texte. Ces gardes filtrent à la
// source, à la frappe comme au collage.
//
// Entiers positifs uniquement (ni signe, ni séparateur décimal) : c'est ce que
// valent tous les réglages de grille du document — nombres de colonnes et de
// lignes, largeurs en douzièmes, espacement en pixels.

// Les touches d'édition et de navigation (Backspace, Tab, ArrowUp, Home...) ont
// un `key` de plus d'un caractère : les laisser passer sur ce critère évite de
// devoir les énumérer. Les combinaisons à modificateur sont laissées aussi,
// sinon copier/coller et tout sélectionner cesseraient de fonctionner.
export const blockNonDigitKey = (event) => {
  if (event.ctrlKey || event.metaKey || event.altKey) return;
  const { key } = event;
  if (!key || key.length > 1) return;
  if (!/\d/.test(key)) event.preventDefault();
};

export const blockNonDigitPaste = (event) => {
  const pasted = event.clipboardData?.getData('text') ?? '';
  if (!/^\d+$/.test(pasted.trim())) event.preventDefault();
};

// À étaler sur un <InputNumber>. `precision` couvre ce qui échappe au clavier :
// valeur non entière héritée du modèle, ou arrondie par les flèches. Sans effet
// quand le champ définit son propre `formatter`, qui a la priorité côté antd.
export const integerInputProps = {
  precision: 0,
  onKeyDown: blockNonDigitKey,
  onPaste: blockNonDigitPaste,
};
